module.exports = __webpack_public_path__ + "img/group_002.fa22cddc.svg";